(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@ls/js-utils"), require("react"), require("prop-types"));
	else if(typeof define === 'function' && define.amd)
		define(["@ls/js-utils", "react", "prop-types"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("@ls/js-utils"), require("react"), require("prop-types")) : factory(root["@ls/js-utils"], root["react"], root["prop-types"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(self, function(__WEBPACK_EXTERNAL_MODULE__141__, __WEBPACK_EXTERNAL_MODULE__156__, __WEBPACK_EXTERNAL_MODULE__99__) {
return 